import { render, staticRenderFns } from "./BlockNotification.vue?vue&type=template&id=5b12ced2&scoped=true&lang=pug&"
import script from "./BlockNotification.vue?vue&type=script&lang=js&"
export * from "./BlockNotification.vue?vue&type=script&lang=js&"
import style0 from "./BlockNotification.vue?vue&type=style&index=0&id=5b12ced2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b12ced2",
  null
  
)

export default component.exports